module.exports = __webpack_public_path__ + "static/media/landing-page-banner1.31106d7f.svg";